import { PlaeeOrderResponseDtoOrdStatus } from '@/lib/models';
import type { PlaeeOrderResponseDto } from '@/lib/models';

/**
 * True when an order ended without a single fill: FIX OrdStatus Canceled
 * (`4`) or Expired (`C`) with zero cumulative quantity. Nothing executed —
 * any reserved funds are released. (Used, among others, as the unfilled-IOC
 * verdict in the limit-order sheet.)
 */
export function isUnfilledCancelled(order: Pick<PlaeeOrderResponseDto, 'ordStatus' | 'cumQty'>): boolean {
  const cancelled =
    order.ordStatus === PlaeeOrderResponseDtoOrdStatus.NUMBER_4 || order.ordStatus === PlaeeOrderResponseDtoOrdStatus.C;
  return cancelled && order.cumQty === 0;
}
